import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const PlaidOnEvent = gql`
  mutation PlaidOnEvent($input: PlaidOnEventInput!) {
    plaidOnEvent(input: $input) {
      ... on PlaidOnEventSuccess {
        message
      }
      ... on PlaidOnEventError {
        ...error
      }
    }
  }
  ${error}
`;
